import ContactPageHeader from './components/contactPageHeader/ContactPageHeader';
import ContactPageForm from './components/contactPageForm/ContactPageForm';
import Layout from '@/components/Layout/Layout.jsx';
import SEO from '@/components/SEO/SEO.jsx';

const ContactPage = () => {
  return (
    <Layout>
      <SEO
        title='Kontakt – Rentasvet'
        description='Kontaktirajte tim Rentasveta. Tu smo da odgovorimo na sva vaša pitanja o rentiranju, oglašavanju i korišćenju platforme. Pišite nam – odgovaramo brzo!'
        keywords='kontakt, Rentasvet kontakt, podrška, pitanja o rentiranju, oglašavanje, pomoć, kontakt forma'
        url='/contact'
        lang='sr'
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'LocalBusiness',
          name: 'Rentasvet',
          url: 'https://rentasvet.rs',
          description: 'Prvi srpski sajt za rentiranje. Iznajmi bilo šta direktno – bez provizije i posrednika.',
          address: { '@type': 'PostalAddress', addressCountry: 'RS', addressLocality: 'Srbija' },
          contactPoint: {
            '@type': 'ContactPoint',
            contactType: 'customer support',
            url: 'https://rentasvet.rs/contact',
            availableLanguage: ['Serbian', 'English'],
          },
          sameAs: ['https://www.facebook.com/rentasvet', 'https://www.instagram.com/rentasvet'],
        }}
      />
      <main className='w-full'>
        <ContactPageHeader />
        <ContactPageForm />
      </main>
    </Layout>
  );
};

export default ContactPage;
